import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, Observable, of } from 'rxjs';
import { ItemOptionComponent } from '../components/item-option/item-option.component';
import { SettingService } from 'src/app/shared/services/setting.service';
import { catchError, finalize, tap } from 'rxjs/operators';
//import * as momentTimeZone from 'moment-timezone';
import momentTimeZone from 'moment-timezone';
//import * as moment from 'moment';
import moment from 'moment';
import { IProvinceTax } from './tax.service';
import { IAddress } from 'src/app/shared/services/address.service';
import { Storage } from '@ionic/storage';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { AlertController } from '@ionic/angular';
import { GoogleApiService } from 'src/app/shared/services/google-api.service';
import { IGeopoint } from '../pages/list-page/list-page.component';
import { IAvailableHour } from './order.service';
import { Result } from '@zxing/library';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';

export enum EOpenHoursDay {
  None = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 4,
  Thursday = 8,
  Friday = 16,
  Saturday = 32,
  Sunday = 64
}

export interface IStoreAddress {
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  postalCode: string;
  province: string;
  street: string;
  streetNumber: string;
  suiteNumber: string;
}

export interface IStorePhone {
  number: string;
  extension: string;
}

export interface IStore {
  id: string;
  address: IStoreAddress;
  displayName: string;
  allowDelivery: boolean; //this are now for mobile app
  allowPickup: boolean; //this are now for mobile app
  allowShipping: boolean; //this are now for mobile app
  allowDeliveryBrowser: boolean;
  allowPickupBrowser: boolean;
  allowShippingBrowser: boolean;
  allowSales: boolean;
  averageOrderPrice: number;
  identifierName: string;
  merchantId: string;
  neq: string;
  tps: string;
  tvq: string;
  phone: IStorePhone;
  freeDelivery: any;
  freeShipping: any;
  _distance?: number;
  deliveryRadius: number;
  deliveryPrice: number;
  orderPrepareTimeMin: number;
  orderPrepareTimeMax: number;
  areaIdentifier: string;
  openHours: IOpenHour[];
  postalCodesDelivery: string[];
  provinceTaxes: IProvinceTax[];
  timeZoneInfos: TimeZoneInfo;
  deliveryDistances: IDeliveryDistance[];
  postalCodesPrice: IPostalCodeDelivery[];
  acceptingOrders?: boolean;
  acceptingPickupOrders?: boolean;
  acceptingDeliveryOrders?: boolean;
  orderStepCounts: IOrderStepCount[];
  specialDays: ISpecialDay[];
  _status: string;
  _disabled: boolean;
  _disabledDelivery : boolean;
  _disabledPickup: boolean;
  _openHour: string;
  _openDeliveryHour: string;
  _openPickupHour: string;
  _closedHour: string;
  _closeDeliveryHour: string;
  _closePickupHour: string;
  _closedAfterClosedHours: boolean;
  _todayOfferDelivery: boolean;
  _todayOfferPickup: boolean;
  externalProviderId?:string;
  allowedProvince: IAllowedProvinces
  isDoorDashDrive: boolean;
  isUberDirect: boolean;
  strictBillingAddress: boolean;
  deliveryMinAmount: number;
  deliveryMaxAmount: number;
  shippingMinAmount: number;
  shippingMaxAmount: number;
  convenienceFee : number;
  lastOnline?: Date;
  deliveryZone?: deliveryZone;
  useFlagShipRates?: boolean;
  useThirdPartyInventory: boolean;
  skipAllergies: boolean;
  paymentRestriction: IPaymentRestriction;
  terminalId: string;
  tableOrderConfig: ITableOrderConfig;
  askUtensils: boolean;

  timeMax?: number;
  timeMin?: number;
  PrepareTimeMax?: number;
  cloverPaymentInfo: CloverPaymentInfo;
}

export interface ITableOrderConfig{
  allowTable: boolean;
  payWithPOS: boolean;
  clearTime: string;
  useGeolocation: boolean;
  useSecureOrders: boolean;
  geolocationDistance: number;
  secureOrdersTime: number;
}

export interface IPaymentRestriction {
  daysInterval: number;
  transactionCount: number;
  use3DSecure: boolean;
}

export interface deliveryZone{
  //googleLink: string;
  deliveryZone : DeliveryZone[]
}
export interface DeliveryZone{
  name : string;
  points: points[];
  price: number;
}

export interface points{
  latitude: string;
  longitude: string;
}

export interface IAllowedProvinces {
  allowOtherProvince: boolean, 
  allowedProvinces: any[]
}
export interface IStoreOld {
  id: string;
  name: string;
  area: string;
  deliveryPrice: number;
  distance: number;
  freeDelivery: boolean;
  freeDeliveryOver: number;
  timeMin: number;
  timeMax: number;
  averageOrderPrice: number;
}

export interface ITranslatableText {
  translations: { [key: string]: string };
}

export interface IMeasurements{
  dimensions: IDimensions,
  weight: number
}

export interface IOpenHour {
  days: number;
  openHours: string;
  closeHours: string;
  allowDelivery: boolean;
  allowPickup: boolean;
  rangeHours: IRangeHour[];
}

export interface IRangeHour{
  id : number;
  openHours: string;
  closeHours: string;
  allowDelivery: boolean;
  allowPickup: boolean;
}

export interface IHours {
  openHours?: string;
  closeHours?: string;
}

export interface IMenuCategory {
  id: string;
  name: ITranslatableText;
  items: IMenuItem[];

  _open?: boolean;
}

export interface IMenuItem {
  id: string;
  name: ITranslatableText;
  price: number;
  options: IMenuItemOptionCategory[];
}

export interface IMenuItemOptionCategory {
  id: string;
  name: ITranslatableText;
  min: number;
  max: number;
  items: IMenuItemOption[];
}

export interface IMenuItemOption {
  id: string;
  itemId?:string;
  categoryId?: string;
  name: ITranslatableText;
  itemNumber?: string;
  price: number;
  quantity: number;
  categoryItems?: IMenuItemOption[];
  chainItemOptions?: IMenuItemOption[];
  _selected: boolean;
  itemDetailCombination?: IItemDetailCombination[];
  isActive?: boolean;
  externalPOSId?: string;
  _optionCategoryId?: string; // question id of the chain item
  _chainItemId?: string; // chain item id
}

export interface ISpecialDay {
  day: string;
  isClosed: boolean;
  openHours: string;
  closeHours: string;
}

/** new interfaces for real menu */

export interface IStoreMenu {
  id: string;
  merchantId: string;
  name: ITranslatableText;
  storeMenuCategories: IStoreMenuCategory[];
  deployDate : string;
}

export interface IStoreMenuCategory {
  name: ITranslatableText;
  startTime: string;
  endTime: string
  isTakeOut: boolean;
  isDelivery: boolean;
  isTableOrder: boolean;
  isTwoForOneDeal?: boolean;
  storeMenuCategoryItems: IStoreMenuCategoryItem[];
  imageDisplayName?: string;
  imageShortName?: string;
  _open?: boolean;
  _image?: string | ArrayBuffer;
}

export interface IStoreMenuCategoryItem {
  itemId: string;
  item: IStoreMenuItem;
  itemOptionCategories?: IStoreMenuCategoryItem[];
  subItems?: IStoreMenuItem[];
  isPermitQuantities?: boolean;

  parentItem?: IStoreMenuItem; // only use this if there's a parent item to reference.
  isDeleted?: boolean;  // ← ADD THIS
}

export interface IStoreMenuItem {
  id: string;
  itemStoreId?: string;
  parentItemId?: string; // could be a sub item
  itemName: ITranslatableText;
  itemNumber: string;
  itemDescription: IDescription;
  taxEligible: boolean;
  price: number;
  descriptionExtended?: IDescriptionExtended;
  calPerServing: string;
  calPerItem: string;
  allergens: ITranslatableText;
  itemImageShortName: string;
  _itemImage?: any;
  itemOptionCategories: IStoreMenuItemOptionCategory[];
  isDelivery: boolean;
  isActive: boolean;
  isActiveDoorDashDrive: boolean;
  isTakeOut: boolean;
  isOrderTable: boolean;
  isShipping: boolean;
  isHorizontalDisplay: boolean;
  isFoodItem?: boolean;
  isRetailItem? :boolean;
  isAlcohol?: boolean;
  itemBrandId? :string;
  itemColors: IColor[];
  itemSizes: ISize[];
  quantity?: number; 
  itemCategories?: ICategory[];
  itemSubCategories?: any[]
  itemDepartments: IItemDepartment[];
  isInventoryExist?: boolean;
  isInventoryActive?: boolean;
  description: ITranslatableText;
  itemDetailCombination?: IItemDetailCombination[];
  itemAvailableHour?: IAvailableHour[];
  externalPOSId: string;
  skipAllergies: boolean;
  
  externalProviderType?: number;

  _imageUrl?: string | null;
  subItemAskBefore?: boolean;
  subItemShowInMenu?: boolean;
  nameOverwrite?: ITranslatableText;
  itemPreparation?: IItemPreparation;
}

export interface IItemDetailCombination {
  code: string,
  colorId: string,
  id: string,
  isDeleted: false,
  price: number,
  sizeId: string,
  measurementsId: string,
  size?: ITranslatableText,
  color?: ITranslatableText,
  measurements?: IMeasurements,
  quantity: number,
  modifier?: number
}

export interface IItemDepartment {
  id: string,
  name: ITranslatableText
}

export interface ICategory {
  id: string,
  name: ITranslatableText
}

interface ISize {
  abbreviation: ITranslatableText,
  id: string,
  itemId: string,
  merchantId: string,
  name: ITranslatableText,

  isDeleted?: boolean
}

interface IColor {
    abbreviation: ITranslatableText,
    id: string,
    itemId: string,
    merchantId: string,
    name: ITranslatableText,

    colorImage?: any,
    code?: any,
    isDeleted?: boolean
}

interface IDimensions{
  length: number,
  width: number,
  height: number
}

export interface IDescriptionExtended {
  title: ITranslatableText,
  description: ITranslatableText
}

export interface IDescription {
  title: ITranslatableText,
  description: ITranslatableText
}

export interface IStoreMenuItemOptionCategory {
  id: string;
  itemId: string;
  name: ITranslatableText;
  options: IStoreMenuItemOption[];
  isMultiple: boolean;
  autoSkip: boolean;
  multipleLimit?: number;
  showItemDefaultPrice: boolean;
  isOptionnal: boolean;
  overrideDefaultPrice: boolean;
  chainItem: boolean;
  isMultipleUnlimited: boolean;
  isHorizontalDisplay: boolean;
}

export interface IStoreMenuItemOption {
  optionId: string;
  itemId: string;
  categoryId: string;
  modifier: number;
  option: IStoreMenuItemOptionOption;
  chainItemOptionCategories: IStoreMenuItemOptionCategory[];
}

export interface IStoreMenuItemOptionOption {
  id: string;
  categoryId: string;
  merchantId: string;
  name: ITranslatableText;
  price: number;
  quantity: number;
  itemDescription?: IDescription;
  descriptionExtended?: IDescriptionExtended;
  imageShortName?: string;
  imageDisplayName?: string;
  categoryItems?: IMenuItemOption[];
  _selected: boolean;
  _image?: any;
  itemColors?: IColor[];
  itemSizes?: ISize[];
  itemDetailCombination?: IItemDetailCombination[];
  
  totalQuantity?: number;
  isInventoryExist?: boolean;
  isInventoryActive?: boolean;
  isActive?: boolean;
}


export interface TimeZoneInfo {
  timeZoneId: string;
  name: string;
  offset: number;
}

export interface IItem {  
  description: ITranslatableText; 
  id: string;
  isActive: boolean;
  isDeleted: boolean;  
  itemName: ITranslatableText;
  itemNumber: string;  
  merchantId: string;
  price: number;
  taxEligible: boolean;
}

export interface IDeliveryDistance {
  distance: number;
  price: number;
}

export interface IPostalCodeDelivery {
  postalCode: string;
  price: number;
}

export interface IFindItem {
  merchantId: string;
  itemId: string;
}

export interface IOrderStepCount {
  orderType: number;
  stepCount: number;
}

export interface IDoorDashDriveEstimationResponse {
  isDeliveryPossible : boolean;
  errorMessage : string;
}

export interface CloverPaymentInfo {
  cloverId : string;
  locationId : number; 
  privateToken : string;
  publicToken : string;
  useOAuth: boolean;
  oAuthToken: string;
  pakmsToken: string;
}

export const OrderTypeEnum = {
  Pickup: 0,
  Delivery: 1
}

export interface IItemImageBank {
  path: string;
  result: Blob;
}

export interface ICacheMenu {
  storeId: string,
  menu: IStoreMenu;
}

export interface IImageCache {
  shortName: string,
  imageUrl: string,
}

export interface IItemPreparation{
  isActive: boolean;
  prepareTime: number;//in hours
  prepareDays: number;//calendar days
  weekDays: number;
}

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  toggleNav: boolean = false;
  findItem: IFindItem;
  geopoint: IGeopoint;

  selectedStore: boolean = true;

  storesPreload: IStore[] = [];
  calltype: string = "";

  SavedStoreMenu: ICacheMenu[] = [];
  InitMenus: boolean = false;

  private storesPreloadSubject = new BehaviorSubject<IStore[]>([]);
  public storesPreload$ = this.storesPreloadSubject.asObservable(); 

  get getSelectedStore(): boolean {
    return this.selectedStore;
  }

  set setSelectedStore(selected) {
    this.selectedStore = selected;
  }

  getItemImageBank: IItemImageBank[] = [];
  menuImageCache: IImageCache[] = [];
  itemImageCache: IImageCache[] = [];

  constructor(private http: HttpClient,
    private setting: SettingService,
    private alertCtrl: AlertController,
    private storage: Storage,
    private googleApiService: GoogleApiService,
    private apiController: ApiControllerService) { }


  async PreloadMenuCatAndItemImage(/*item?: IStoreMenuCategoryItem, menuCategory?: IStoreMenuCategory*/ menu: IStoreMenu) {

    for(var i = 0; i < menu.storeMenuCategories.length; i++) {
      var menuCategory = menu.storeMenuCategories[i];
      
      if (menuCategory.imageShortName) {
        const catShortName = menuCategory.imageShortName;

        // Check cache first
        const cached = this.menuImageCache.find(
          x => x.shortName === catShortName
        );

        if (!cached) {
          //continue;

          try {
            // Not cached, fetch it
            const apiUrl = this.setting.apiUrl(
              `/Menu/GetMenuItemImage?name=${catShortName}`
            );

            const blob = await firstValueFrom(
              this.http.get(apiUrl, { responseType: 'blob' })
            );

            const imageUrl = URL.createObjectURL(blob);

            this.menuImageCache.push({
              shortName: catShortName,
              imageUrl
            });
          } catch (err) {
            console.log("error");
          }
          

        }
      }

      // then you get the items inside and download each of them
      for(var y = 0; y < menuCategory.storeMenuCategoryItems.length; y++) {
        var item = menuCategory.storeMenuCategoryItems[y];
        
        if (!item?.item?.itemImageShortName) {

          // default image
          const itemShortName = this.setting.getItemPlaceHolderPath();

          // Check cache first
          const cached = this.itemImageCache.find(
            x => x.shortName === itemShortName
          );

          if (!cached) {
            // Not cached, fetch it
            const apiUrl = this.setting.apiUrl(
              `/Menu/GetMenuItemImage?name=${itemShortName}`
            );

            try {
              const blob = await firstValueFrom(
                this.http.get(apiUrl, { responseType: 'blob' })
              );

              const imageUrl = URL.createObjectURL(blob);

              this.itemImageCache.push({
                shortName: itemShortName,
                imageUrl
              });
            } catch (err) {
              console.log(err);
            }
          }

        } else {
          const itemShortName = item.item.itemImageShortName;

          // Check cache first
          const cached = this.itemImageCache.find(
            x => x.shortName === itemShortName
          );

          if (!cached) {
            // Not cached, fetch it
            try {
              const apiUrl = this.setting.apiUrl(
                `/Menu/GetMenuItemImage?name=${itemShortName}`
              );

              const blob = await firstValueFrom(
                this.http.get(apiUrl, { responseType: 'blob' })
              );

              const imageUrl = URL.createObjectURL(blob);

              this.itemImageCache.push({
                shortName: itemShortName,
                imageUrl
              }); 
              

            } catch (err) {
              console.log(err);
              console.log("fallback image");


              const itemShortNameBackup = this.setting.getItemPlaceHolderPath();

              // Check cache first
              const cachedBackup = this.itemImageCache.find(
                x => x.shortName === itemShortNameBackup
              );

              const apiUrl = this.setting.apiUrl(
                `/Menu/GetMenuItemImage?name=${itemShortNameBackup}`
              );

              try {
                const blob = await firstValueFrom(
                  this.http.get(apiUrl, { responseType: 'blob' })
                );

                const imageUrl = URL.createObjectURL(blob);

                this.itemImageCache.push({
                  shortName: itemShortNameBackup,
                  imageUrl
                });
              } catch (err2) {
                console.log(err2);
              }

              
            }
            
          }

        }
      }
    }
  } 
    
  getStore(id: string): Observable<IStore> {
    return Observable.create(o => {

      const cachedStore = this.storesPreload.find(store => store.id === id);

      if (cachedStore) {
        console.log('Loaded from cache');
        o.next(cachedStore);
        o.complete();
        return;
      }

      var storeData = this.storesPreload.find(store => store.id == id)
      if(storeData) {
        o.next(storeData);
      } else {

        this.getStores().subscribe((data: IStore[]) => {
          storeData = this.storesPreload.find(store => store.id == id)
          if(storeData) {
            o.next(storeData);
          }
        });
        
        /*
        //this.http.post(this.setting.apiUrl('Store/Find'), { merchantId: this.setting.getMerchantId(), id: id })
        this.apiController.post(this.setting.apiUrl('Store/Find'), { merchantId: this.setting.getMerchantId(), id: id })
          .pipe(
            catchError(() => { return of(null) }),
            finalize(() => {
              o.complete();
            })
          )
          .subscribe((data: IStore) => {
            o.next(data);
          })
        */
      }

      
    });
  }

  getItem(id: string):  Observable<any> {
    this.findItem = {
        merchantId: this.setting.getMerchantId(),
        itemId: id
    }
    return Observable.create(o => {
      //this.http.post(this.setting.apiUrl('Item/FindAllItems'), this.findItem)
      this.apiController.post(this.setting.apiUrl('Item/FindAllItems'), this.findItem)
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe((data: IStore) => {
          o.next(data);
        })
    });
  }

  getStores(ignoreAllowSales: boolean = false, callType: string = "", preloadingInit: boolean = false): Observable<IStore[]> {
    
    // it seems it gives different results. i'll fix it a bit later
      return Observable.create(o => {
        if(this.storesPreload.length > 0 && callType == this.calltype && !preloadingInit && this.InitMenus) {
          if(!ignoreAllowSales) {
          
            var allowSalesStores:IStore[] = [];
            for(var i = 0; i < this.storesPreload.length; i++){
              var store = this.storesPreload[i];
              if(store.allowSales) {
                allowSalesStores.push(store);
              }
            }
            o.next(allowSalesStores);
            o.complete();
          } else {
            o.next(this.storesPreload);
            o.complete();
          }
          
        } else {

          //this.http.post(this.setting.apiUrl('Store/FindAll'), { merchantId: this.setting.getMerchantId(), ignoreAllowSales: ignoreAllowSales })
          this.apiController.post(this.setting.apiUrl('Store/FindAll'), { merchantId: this.setting.getMerchantId(), ignoreAllowSales: ignoreAllowSales })
          .pipe(finalize(() => {
            o.complete();
          }),
          tap(data => {

          }))
          .subscribe((data: IStore[]) => {

            /*data.sort((t, n) => t.distance - n.distance);
            let currentIndex = page * pageSize;
            data = data.slice(currentIndex - pageSize, currentIndex + pageSize - 1);*/

            if(ignoreAllowSales && !this.InitMenus) {
              this.storesPreload = data; // caching the stores
            } else if(this.storesPreload.length < 1) {
              this.storesPreload = data; // caching the stores
            }

            if(!this.InitMenus){

              // temp -> load the first store menu only
              for(var i = 0; i < this.storesPreload.length; i++) {
                
                if(i < 1) {
                  // if needed review this to control the stores that passes through. -> track any of the changes, thus far, everything appears to work as normal (06/25/2026)
                  /*
                  if(!ignoreAllowSales) {
          
                    
                    var allowSalesStores:IStore[] = [];
                    for(var i = 0; i < this.storesPreload.length; i++){
                      var store = this.storesPreload[i];
                      if(store.allowSales) {
                        allowSalesStores.push(store);
                      }
                    }
                    o.next(allowSalesStores);
                    o.complete();
                  } else {
                    o.next(this.storesPreload);
                    o.complete();
                  }
                  */

                  //if(store.allowSales) {
                    var store = this.storesPreload[i];
                    this.getMenu(store.id, null, null).subscribe(async (menuData: IStoreMenu) => {
                      this.PreloadMenuCatAndItemImage(menuData);
                    });
                  //}
                  
                }
                
                  /*
                // only loads menu of stores with "allowSales"
                //if(store.allowSales) {
                  var store = this.storesPreload[i];
                  this.getMenu(store.id, null, null).subscribe(async (menuData: IStoreMenu) => {
                    this.PreloadMenuCatAndItemImage(menuData);
                  });
                //}
                */
                
                
              }

              if(preloadingInit) {
                this.InitMenus = true;
              }
            }

            this.storesPreloadSubject.next(data);
            o.next(data);
          });
          
        }
      });
    

    /*return Observable.create(o => {
      this.http.get('assets/stores.json')
      .subscribe((data: IStore[]) => {
        data.sort((t, n) => t.distance - n.distance);
        let currentIndex = page * pageSize;
        data = data.slice(currentIndex - pageSize, currentIndex + pageSize - 1);
        o.next(data);
        o.complete();
      });
    });*/
  }

  getFutureMenu(storeId: string, orderDate: string, orderTime: string): Observable<IStoreMenu[]>{
    return Observable.create(o => {
    
      //this.http.post(this.setting.apiUrl('Menu/GetFutureMenus'), {
      this.apiController.post(this.setting.apiUrl('Menu/GetFutureMenus'), {
        storeId: storeId,
        timeZone: momentTimeZone().format("Z"),
        orderDate: orderDate,
        orderTime: orderTime
      })
        // this.http.get('assets/menu.json')
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe((data: IStoreMenu[]) => {
          o.next(data);
        });
    });
  }

  getMenu(storeId: string, orderDate: string, orderTime: string, deliveryType? : string): Observable<IStoreMenu> {
    return Observable.create(o => {

      var cachedData = this.SavedStoreMenu.find(data => data.storeId == storeId);
      if(cachedData) {
        o.next(cachedData.menu);
        o.complete();
      } else {
        //this.http.post(this.setting.apiUrl('Menu/GetMenu'), {
        this.apiController.post(this.setting.apiUrl('Menu/GetMenu'), {
          storeId: storeId,
          timeZone: momentTimeZone().format("Z"),
          orderDate: orderDate,
          orderTime: orderTime,
          deliveryType : deliveryType
        })
          // this.http.get('assets/menu.json')
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe((data: IStoreMenu) => {
            var validateData = this.SavedStoreMenu.find(data => data.storeId == storeId)
            if(!validateData) {
              this.SavedStoreMenu.push({storeId: storeId, menu: data});
            }
          
            o.next(data);
          }
        );

      }
    
      
      

      
    });
  }

  getItemImage(path: string): Observable<Blob> {
    return Observable.create(o => {
      const existing = this.getItemImageBank.find(imageBank => imageBank.path === path);
      if(existing) {
        o.next(existing.result);
        o.complete();
      } else {
        //this.http.post(this.setting.apiUrl('Menu/GetMenuItemImage'), {
        this.apiController.post<Blob>(this.setting.apiUrl('Menu/GetMenuItemImage'), {
          path: path
        }, { responseType: 'blob' })
          /*
          .pipe(finalize(() => {
            o.complete();
          }))
          */
          .subscribe(
            
            result => {
              this.getItemImageBank.push({ path, result });
              o.next(result);
              o.complete();
            },
            res => {
              if (res.status != 400)
                // this.alert.showUnexpectedErrorMsg();
                o.error(res);
            }
          )
      }

    
      
    });
  }

  getLocationInfo(locationId: string)
  {
    return Observable.create(o => {
      /* this.http.get(this.setting.getLegacySmaUrl(`V2/Agenda/GetLocationInfo?locationId=${+locationId}`)).subscribe(info => {
        return o.next(info)
      },
      res => {
        if (res.status == 404)
        {
          o.error(res);
          //Temporary
          this.alertCtrl.create({
            header: 'Alert',
            message: 'Reservation is not available for this restaurant!',
            buttons: [
              {
                text: 'Okay',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  
                }
              }
            ]
          }).then(al=>{
            al.present();
          });
      
      }
      }
      ) */

      this.apiController.get(this.setting.getLegacySmaUrl(`V2/Agenda/GetLocationInfo?locationId=${+locationId}`)).subscribe(info => {
        return o.next(info)
      },
      res => {
        if (res.status == 404)
        {
          o.error(res);
          //Temporary
          this.alertCtrl.create({
            header: 'Alert',
            message: 'Reservation is not available for this restaurant!',
            buttons: [
              {
                text: 'Okay',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  
                }
              }
            ]
          }).then(al=>{
            al.present();
          });
      
      }
      }
      )
    })
  }

  setOpeningHours(store: IStore) {
    let isClosed = true;
    let useSpecialDayIsClosed = false;
    let closedAfterPreparation = false;


    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    //Was date here, maybe this
    let d = moment();
    let dayName = days[d.day()];   
    


    if (store.openHours.length == 0) {
      //No time set, we cant determine what to show, make it disabled
      store._disabled = true;
    }

    store.openHours.forEach(t => {
      if (t.days & EOpenHoursDay[dayName]) {
        //for(let element of t.rangeHours){
      for(let element of t.rangeHours){   
        
        //t.rangeHours.forEach(element => {
        
        //Flag if the store is allowing pickup/delivery for today
        if(element.allowDelivery){
          store._todayOfferDelivery = true ; 
        }
        if(element.allowPickup){
          store._todayOfferPickup = true ;
        }
     // }
        //for(let element of t.rangeHours){
       // store._todayOfferDelivery = element.allowDelivery != undefined ? element.allowDelivery : true;
        //store._todayOfferPickup = element.allowPickup != undefined ? element.allowPickup : true;
     
        var format = 'hh:mma'
        let now = moment();
        let beforeTime = moment(element.openHours, format);
        let afterTime = moment(element.closeHours, format);

        if (now.isBetween(beforeTime, afterTime)) {
          //this is just to identify if the store is marked as closed because of the max time
          now = now.add(store.orderPrepareTimeMax, 'minutes'); 
          if (!now.isBetween(beforeTime, afterTime)) {
            closedAfterPreparation = true;
            store._status = 'General.ClosedPreparationTime';
          }
        } 

        let useSpecialDayHoursBefore = false;
        let useSpecialDayHoursAfter = false;    

        //Check if we must overwrite with special days
      
        if (store.specialDays) {
          if (store.specialDays.length > 0) {
           
            for(let i = 0; i < store.specialDays.length; i++) {
              let dayMonth = store.specialDays[i].day.split("/");

              let currentDay = dayMonth[0];
              let currentMonth = dayMonth[1];

              let dateDay = d.month() + 1;
              let dateMonth = now.format('D');

              let dateDayString = "";

             /* if (parseInt(currentDay) < 10) {
                currentDay = "0" + currentDay;
              }

              if (parseInt(currentMonth) < 10) {
                currentMonth = "0" + currentMonth;
              }*/

              if (dateDay < 10) {
                dateDayString = "0" + dateDay.toString();
              } else {
                dateDayString = dateDay.toString();
              }

              if (parseInt(dateMonth) < 10) {
                dateMonth = "0" + dateMonth;
              }

              if (dayMonth[0] == dateDayString) {             
                //Check if same day number too
                if (dayMonth[1] == dateMonth) {
                    //Same day and month, must overwrite with special day values
                    if (store.specialDays[i].isClosed) {
                      useSpecialDayIsClosed = true;        
                      store._closedAfterClosedHours = true;            
                      store._status = "General.SpecialDayClosed";                     
                    } 

                    if (store.specialDays[i].openHours != "") {
                      beforeTime = moment(store.specialDays[i].openHours, format);
                      useSpecialDayHoursBefore = true;
                    }

                    if (store.specialDays[i].closeHours != "") {
                      afterTime = moment(store.specialDays[i].closeHours, format);
                      useSpecialDayHoursAfter = true;
                    }
                }
              }
            }
          }  
        }
      
        //When it is midnight, must set after time as midnight next day, otherwise it assume midnight today in the form of 00:00:00
        if (element.closeHours == "12:00am") {
          afterTime = afterTime.add(1, "days");
        }
       
        var storeTZOffset = moment.tz.zone(store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime());
        var clientTZOffset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());

        if (storeTZOffset != clientTZOffset) {
            //Do something when we have a different offset, otherwise, time are the same
            let diff = storeTZOffset - clientTZOffset;
            
            
          store._openHour = beforeTime.add(diff / 60, 'hours').format(format);
          //store._openDeliveryHour = beforeTime.add(diff / 60, 'hours').format(format);
          //store._openPickupHour = beforeTime.add(diff / 60, 'hours').format(format);


          store._closedHour = afterTime.add(diff / 60, 'hours').format(format);
          //store._closeDeliveryHour = beforeTime.add(diff / 60, 'hours').format(format);
          //store._closePickupHour = beforeTime.add(diff / 60, 'hours').format(format);
        } else {
          if (useSpecialDayHoursBefore && useSpecialDayHoursAfter) {
            store._closedHour = afterTime.format(format);
            store._openHour = beforeTime.format(format);
          } else if (useSpecialDayHoursBefore && !useSpecialDayHoursAfter) {
            store._openHour = beforeTime.format(format);
            store._closedHour = element.closeHours;
          } else if (!useSpecialDayHoursBefore && useSpecialDayHoursAfter) {
            store._openHour = element.openHours;
            store._closedHour = afterTime.format(format);
          } else {
            store._closedHour = element.closeHours;
            store._openHour = element.openHours; 
          }
        }
       
        if (now.isBetween(beforeTime, afterTime) && !useSpecialDayIsClosed) {
            store._disabledDelivery = true;
            store._disabledPickup = true;
            if(element.allowDelivery){
              store._openDeliveryHour = store._openHour;
              store._closeDeliveryHour = store._closedHour;
              store._disabledDelivery = false;
            
            }if(element.allowPickup){
              store._openPickupHour = store._openHour;
              store._closePickupHour =  store._closedHour;
              store._disabledPickup = false;
            }

            if (!element.allowDelivery && !element.allowPickup) {
              store._disabled = true;
              isClosed = true;              
            } else {            
              isClosed = false;
              store._disabled = false;
            }
            break;
          //isClosed = false;
          //store._disabled = false;
          //store._closedAfterClosedHours = false;
          
        } else {
          store._disabled = true;
          store._disabledDelivery = true;
          store._disabledPickup = true;
        }

        //_disabled = true && _closedAfterClosedHours = true = magasin ouvert aujourd'hui, mais apres heure d'ouverture
        //_disabled = true && _closedAfterClosedHours = false = magasin fermer pour la journ/e
        //_disabled = false = ouvert

        //Check if the now is after the closing time
        if (now.isAfter(afterTime) && !useSpecialDayIsClosed) {
          store._disabled = true;
          store._closedAfterClosedHours = true;
        }
      }
      }
    });

    if (!useSpecialDayIsClosed && !closedAfterPreparation) {
      store._status = isClosed ? "General.Closed" : "General.Open";
    }

    if (isClosed) {
      store._disabled = true;
    }
    
    if(this.storage['previewMenuMode']){
      store._disabled = false;
      store._closedAfterClosedHours = false;
    }
    return store;
  }

  getStoreOpenHoursForDay(store: IStore, date: string) {
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let d = moment(date);
    let dayName = days[d.day()];
    //let hours: IHours[] = null;
    let hours: IHours = null;
    let openHours = null;
    let closeHours = null ; 
  
    store.openHours.forEach(t => {
      if (t.days & EOpenHoursDay[dayName]) {
        for (let element of t.rangeHours){
          if(openHours == null || moment(openHours, 'HH:mm:A') > moment(element.openHours,'HH:mm:A')){
            openHours = element.openHours;
          }
          if(closeHours == null ||  moment(closeHours, 'HH:mm:A') < moment(element.closeHours,'HH:mm:A')){
            closeHours = element.closeHours;
          }

        
        }
    
      }
    });
    if(openHours != null && closeHours != null){
      hours = {
        openHours: openHours,
        closeHours : closeHours 
      }
    }
   
    return hours;
  }

  isStoreOpenSpecificDayAndTime(store: IStore, date: string, time: string, interval: number = undefined) {
    let isOpen = false;
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    //Was date here, maybe this
    let d = moment(date + ' ' + time);
    let dayName = days[d.day()];


    if (store.openHours.length == 0) {
      //No time set, we cant determine what to show, make it disabled
      return isOpen;
    }

    store.openHours.forEach(t => {
      if (t.days & EOpenHoursDay[dayName]) {
       
        var format = 'hh:mma'
        let timeMoment = moment(time, format);

        let beforeTime = moment("00:00", 'hh:mm');
        let afterTime = moment("04:00", 'hh:mm');

        if (timeMoment.isBetween(beforeTime, afterTime, undefined, '[]')) {        
          timeMoment.add(1, 'day');      
        }

        var store_tz_offset = moment.tz.zone(store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime()); 
        var client_tz_offset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());
        var timeDiff = (store_tz_offset - client_tz_offset) / 60

        for(let element of t.rangeHours){
          beforeTime = moment(element.openHours, format).add(timeDiff, 'hour');
          afterTime = moment(element.closeHours, format).add(timeDiff, 'hour');
          if(interval != undefined){
            afterTime = afterTime.subtract(interval, "minutes");
          }
          
          //When it is midnight, must set after time as midnight next day, otherwise it assume midnight today in the form of 00:00:00
          if (element.closeHours == "12:00am") {
            afterTime = afterTime.add(1, "days");
          }


          if (timeMoment.isBetween(beforeTime, afterTime, undefined, '[]')) {
            isOpen = true;
          } else {
            store._disabled = true;
          }
  
          store._closedHour = element.closeHours;
          store._openHour = element.openHours;
          if(isOpen){
            break;
          }
        //}
        }

       // beforeTime = moment(t.openHours, format).add(timeDiff, 'hour');
       // afterTime = moment(t.closeHours, format).add(timeDiff, 'hour');


        //When it is midnight, must set after time as midnight next day, otherwise it assume midnight today in the form of 00:00:00
        // if (t.closeHours == "12:00am") {
        //   afterTime = afterTime.add(1, "days");
        // }

      //   if (timeMoment.isBetween(beforeTime, afterTime, undefined, '[]')) {
      //     isOpen = true;
      //   } else {
      //     store._disabled = true;
      //   }

      //   store._closedHour = t.closeHours;
      //   store._openHour = t.openHours;
      }
    });

    return isOpen;
  }

  setDeliveryPrice(store: IStore, address: IAddress, geopoint?:IGeopoint) {
    //Second check postal code delivery price
    let found = false;
    if (address) {
      for (let i = 0; i < store.postalCodesPrice.length; i++) {
        if (address.postalCode == store.postalCodesPrice[i].postalCode) {
          store.deliveryPrice = store.postalCodesPrice[i].price;
          found = true;
        }
        }
      }

      if(!found){
        

          store.deliveryZone.deliveryZone.forEach(zone => {
            if(this.inside(geopoint, zone.points)){
             
              store.deliveryPrice = zone.price
              found = true;
            }
          });
         
         
    }

    
   //Second check radius, dont go in if we found a postal code
   if (!found) {
    
    //  let tempDistance = 0;
      let tempPrice = store.deliveryPrice;    

    if (store.deliveryDistances.length > 0) {
      if (store.deliveryDistances[store.deliveryDistances.length - 1].distance <= store._distance) {
        tempPrice = store.deliveryDistances[store.deliveryDistances.length - 1].price;
      } else {
        for (let i = store.deliveryDistances.length - 1; i >= 0 ; i--) {
          if (store.deliveryDistances[i].distance >= store._distance) {
            //The first one we hit is the fartest valid range to use that fee
          //  store.deliveryPrice = store.deliveryDistances[i].price;
            if (store.deliveryDistances[i - 1] != undefined) {           
              tempPrice = store.deliveryDistances[i - 1].price;
            }         
          }
        }
      }
      store.deliveryPrice = tempPrice;
    }
   
  }  
  
  return store;
}


getDoorDashDriveEstimate(storeId: string, customerAddress : IAddress): Observable<IDoorDashDriveEstimationResponse > {
  return Observable.create(o => {
    //console.log(this.storage.get('deliveryAddress'));
    //this.http.post(this.setting.apiUrl('Store/FindDoorDashDriveEstimate'), { storeId: storeId, dropoffAddress: customerAddress })
    this.apiController.post(this.setting.apiUrl('Store/FindDoorDashDriveEstimate'), { storeId: storeId, dropoffAddress: customerAddress })
      .pipe(finalize(() => {
        o.complete();
      }))
      .subscribe((data: IDoorDashDriveEstimationResponse ) => {
        o.next(data);
      })
  });
}

inside(point : IGeopoint, vs : points[]) {
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
  
  var x = point.longitude, y = point.latitude;
  
  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = parseFloat(vs[i].longitude), yi = parseFloat(vs[i].latitude);
      var xj = parseFloat(vs[j].longitude), yj = parseFloat(vs[j].latitude);
      
      var intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
  }
  
  return inside;
};
}
